module.exports = __webpack_public_path__ + "04_hige_black.e51f688a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/04_hige_black.png
// module id = ZN1p
// module chunks = 0